import { create } from 'zustand';

type Store = {
  isRichContentInView: boolean;
};

export const useReviewsPageStore = create<Store>(() => ({
  isRichContentInView: false,
}));
